import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  role: null,
  sport: null
};

const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    setSignupRole: (state, action) => {
      state.role = action.payload;
    },
    setSignupSport: (state, action) => {
      state.sport = action.payload;
    },
    clearSignupData: () => initialState,
  }
});

export const { setSignupRole, setSignupSport, clearSignupData } = signupSlice.actions;
export default signupSlice.reducer;